module.exports = __webpack_public_path__ + "img/ico_ll2.a3e2fe3a.png";